import React, { useEffect } from 'react'
import { Platform } from 'react-native'
import * as Sentry from 'sentry-expo'
import NavigationTabs from './NavigationTabs'
import OTAUpdate from '@components/OTAUpdate'
import ErrorBoundaryFallback from '@components/ErrorBoundaryFallback'
import { MenuProvider } from '@context/MenuContext'
import { SnackbarProvider } from '@context/SnackbarContext'
import { CurrentUserProvider } from '@context/CurrentUserContext'
import { PendingWorkOrdersProvider } from '@context/PendingWorkOrdersContext'
import { requestTrackingPermissionsAsync } from 'expo-tracking-transparency'

export default function App () {
  useEffect(() => {
    (async () => await requestTrackingPermissionsAsync())()
  }, [])

  if (Platform.OS === 'web') {
    return (
      <AppWithoutBoundary />
    )
  }
  return (
    <Sentry.Native.ErrorBoundary fallback={ ErrorBoundaryFallback }>
      <AppWithoutBoundary />
    </Sentry.Native.ErrorBoundary>
  )
}

const AppWithoutBoundary = () => {
  return (
    <MenuProvider>
      <CurrentUserProvider>
        <PendingWorkOrdersProvider>
          <SnackbarProvider>
            <OTAUpdate />
            <NavigationTabs />
          </SnackbarProvider>
        </PendingWorkOrdersProvider>
      </CurrentUserProvider>
    </MenuProvider>
  )
}
